import { useEffect, useRef, useState } from "react";
import { listCommsSites } from "../../services/comms/comms.service";
import { COMMS_REFRESH_INTERVAL_MS, getCommsErrorMessage } from "./commsSite";
import type { CommsSite, CommsType } from "./commsSite";

export function useCommsSites(type: CommsType) {
    const [sites, setSites] = useState<CommsSite[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const [revision, setRevision] = useState(0);
    const requestId = useRef(0);
    useEffect(() => {
        let mounted = true;
        setLoading(true);
        setSites([]);
        setError(null);
        const load = async () => {
            const current = ++requestId.current;
            try {
                const response = await listCommsSites(type === "online");
                if (!mounted || current !== requestId.current) return;
                if (!response.success || !response.data) throw new Error(response.error?.message || "Failed to load sites");
                setSites(response.data);
                setError(null);
                setRevision(previous => previous + 1);
            } catch (error: unknown) {
                if (mounted && current === requestId.current) setError(getCommsErrorMessage(error, "Failed to load sites"));
            } finally {
                if (mounted && current === requestId.current) setLoading(false);
            }
        };
        void load();
        const interval = setInterval(() => { void load(); }, COMMS_REFRESH_INTERVAL_MS);
        return () => { mounted = false; requestId.current += 1; clearInterval(interval); };
    }, [type]);
    return { sites, loading, error, revision };
}
